import React from 'react';
import { MainContainer, MainHeaderContainer } from './components';
import { InlineToastAlerts } from 'components';
export interface PageProps {
  enableHeaderGlobalBar: boolean;
  pageHeading: string;
  pageDescription?: string;
  headerChildren?: React.ReactElement;
  showAlternateHeaderBar?: boolean;
  referralPage?: any;
}

/**
 * FULL HEADER, LEFT AND RIGHT PANEL LAYOUT (3 COLUMN)
 */
export const FullHeaderLeftSideFullPanelLayout: React.FC<PageProps> = (
  props: any
) => {
  const {
    enableHeaderGlobalBar,
    pageHeading,
    pageDescription,
    headerChildren,
    showAlternateHeaderBar,
    referralPage
  } = props;

  return props.children ? (
    <div className={`container--wrapper `}>
      <MainHeaderContainer
        enableHeaderGlobalBar={enableHeaderGlobalBar || false}
        showAlternateHeaderBar={showAlternateHeaderBar || false}
        referralPage={referralPage}
      >
        {headerChildren}
      </MainHeaderContainer>
      <MainContainer>
        <InlineToastAlerts />
        <section className="page-heading--wrapper">
          <h1 className="main-heading">{pageHeading || ''}</h1>
          <p className="main-description">{pageDescription || ''}</p>
        </section>
        <section className="page-body--wrapper">{props.children}</section>
      </MainContainer>
    </div>
  ) : null;
};
